<ion-header>
    <ion-toolbar>
        <ion-title>
            Team
        </ion-title>
        <ion-buttons slot="end">
            <ion-button  fill="clear" (click)="viewCtrl.dismiss()">
                <ion-icon  slot="icon-only" name="close" color="primary"></ion-icon>
            </ion-button>
        </ion-buttons>
    </ion-toolbar>
</ion-header>
<ion-content>
    <form [formGroup]="formGroup">
        <div class="container">
            <div class="list-container">
                <ion-list class="list-block">
                    <ion-item class="item-block" [ngClass]="{'is-invalid': submitted && formGroup.get('name')?.errors}">
                        <ion-label class="label-block">Name:</ion-label>
                        <ion-input formControlName="name"></ion-input>
                    </ion-item>

                    <ion-item class="item-block" *ngIf="gs.planList.length">
                        <ion-label style="min-width: 80px" class="label-block">Spielplan:</ion-label>
                        <ion-select class="combi" (ionChange)="activePlan = $any($event)"  [placeholder]="gs.planList[activePlan].name">
                            <ion-option *ngFor="let plan of gs.planList; let i = index" [value]="i">
                                {{ plan.name }}
                            </ion-option>
                        </ion-select>
                    </ion-item>

                    <ion-item class="content-end">
                        <ion-select placeholder="{{ types[ls.field.type] }}" (ionChange)="onValueChange('type', $event)"
                            multiple="false">
                            <ion-option *ngFor="let type of types; let i = index" [value]="i">
                                {{ type }}
                            </ion-option>
                        </ion-select>
                    </ion-item>

                    <ion-item class="content-end">
                        <ion-select placeholder="{{ styles[ls.field.style] }}" (ionChange)="onValueChange('style', $event)"
                            multiple="false">
                            <ion-option *ngFor="let style of styles; let i = index" [value]="i">
                                {{ style }}
                            </ion-option>
                        </ion-select>
                    </ion-item>
                    <ion-item>
                        <input class="circle-input" type="color" id="colorWell1" name="head"
                            value="{{ ls.field.color1 }}" (change)="onColorSelect($any($event.target).value, 0);">
                        <span item-end> {{ 'COLOR_ONE' | translate}}</span>
                    </ion-item>
                    <ion-item *ngIf="!(ls.field.style == style.colored)">
                        <input class="circle-input" type="color" id="colorWell2" name="head"
                            (change)="onColorSelect($any($event.target).value, 1);" value="{{ ls.field.color2 }}">
                        <span item-end> {{ 'COLOR_TWO' | translate}}</span>
                    </ion-item>
                </ion-list>
            </div>

            <div class="tshirt-block">
                <svg-tshirt-container [type$]="ls.field.type" [style$]="ls.field.style" class="tshirt-image"></svg-tshirt-container>
                <div class="tshirt-description">
                    <div class="name">{{ team.name }}</div>
                </div>
            </div>

            <div class="buttons-group">
                <button class="btn-submit" block ion-button color="secondary" (click)="onAddTeam()">{{ 'GLOBAL_ADD' | translate }}</button>
                <button class="btn-submit" block ion-button color="secondary" (click)="onDeleteTeam()">{{ 'GLOBAL_DELETE' | translate }}</button>
            </div>

            <ion-list *ngIf="gs.planList[activePlan].teams?.length">
                <ion-item *ngFor="let team of gs.planList[activePlan].teams">
                    <ion-label>
                        {{ team.name }}
                    </ion-label>
                </ion-item>
            </ion-list>
        </div>
    </form>
</ion-content>